module.exports = __webpack_public_path__ + "static/media/done.c9f4fb42.png";